import { Injectable } from '@angular/core';
declare const window: any;
import { Observable, of, throwError } from 'rxjs';
import * as Jsbarcode from 'jsbarcode';
import * as QRCode from 'qrcode';
import JsBarcode = require('jsbarcode');
@Injectable({
  providedIn: 'root',
})
export class IpcService {

  nroRef: string = '';
  msjPrnt: string = '';
  constructor() { }

  get isElectron(): boolean {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(' electron/') > -1) {
      // Electron-specific code
      return true;
    } else {
      return false;
    }
  }

  checkUpdates(): Observable<any> {
    if (this.isElectron) {
      return new Observable((subscriber) => {
        window.api.electronIpcOnce(
          'update_downloaded',
          (_event: any, arg: any) => {
            subscriber.next(arg);
            subscriber.complete();
          }
        );
      });
    } else {
      throw throwError('error');
    }
  }

  checkPosition(position: any) {
    if (this.isElectron) {
      window.api.electronIpcSend('googlePosition', { position });
    } else {
      throw throwError('error');
    }
  }

  cerrarAplicacion() {
    window.api.electronIpcSend('cerrarAplicacion');
  }

  redirecExe() {
    let objetoInfo: any = {
      info: {
        url: 'https://nuvalid-exe.tx.puntosalud.ar'
      }
    };
    window.api.electronIpcSend('redirecExe', JSON.stringify(objetoInfo));
  }

  abrirWhatsapp(numero: string, msj: string) {
    if (this.isElectron) {
      const encodedMessage = encodeURIComponent(msj);
      const url = `https://wa.me/${numero}?text=${encodedMessage}`;
      // const urljson = JSON.stringify(url)
      window.api.electronIpcSend('abrirWhatsapp', url);
    } else {
      const encodedMessage = encodeURIComponent(msj);
      window.open(`https://wa.me/${numero}?text=${encodedMessage}`);
    }
  }

  downloadNuvalidExe(url: string) {
    if (this.isElectron) {
      window.api.electronIpcSend('downloadNuvalidLastestVersion', url);
    } else {
      window.open('url');
    }
  }

  cerrarSplash() {
    console.log('Cerrar splash');
    if (this.isElectron) {
      window.api.electronIpcSend('cerrarSplash');
    }
  }

  async imprimirTicket(ticket: any) {
    const rta = ticket.EncabezadoMensaje?.Rta || ticket.Rta || ticket;

    const textoTicket = rta.MensajePrinter;
    const dataCodigoBarras = rta.CodigoBarras;
    const dataCodigoQR = rta.CodigoQR;

    let barcodeDataURL = '';
    if (dataCodigoBarras) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, dataCodigoBarras, {
        format: 'CODE128',
        width: 2,
        height: 50,
        displayValue: true,
        fontSize: 12,
        font: 'courier'
      });
      barcodeDataURL = canvas.toDataURL();
    }

    let qrDataURL = '';
    if (dataCodigoQR) {
      try {
        qrDataURL = await QRCode.toDataURL(dataCodigoQR, {
          errorCorrectionLevel: 'M',
          width: 150,
          margin: 1
        });
      } catch (err) {
        console.error('Error generando QR', err);
      }
    }

    const printWindow = window.open('', '_blank', 'width=450,height=700,left=500,top=500');

    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Ticket</title>
            <style>
              body {
                font-family: 'Courier New', Courier, monospace;
                font-size: 12px;
                margin: 0;
                padding: 10px;
              }
              .ticket-container {
                width: 100%;
                max-width: 350px; /* Ancho típico de ticketera */
                margin: 0 auto;
              }
              pre {
                white-space: pre-wrap; /* Para que el texto largo baje */
                font-family: inherit;
                margin-bottom: 10px;
              }
              .codes {
                text-align: center;
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
              }
              img {
                max-width: 100%;
              }
              @media print {
                #print-btn { display: none; }
                /* Opcional: forzar salto de página si es necesario */
              }
            </style>
          </head>
          <body>
            <div class="ticket-container">
              <button id="print-btn" onclick="window.print()" style="margin-bottom:10px; padding:5px 10px; cursor:pointer;">IMPRIMIR</button>

              <pre>${textoTicket}</pre>

              <div class="codes">
                ${barcodeDataURL ? `<img src="${barcodeDataURL}" alt="Barcode" />` : ''}
                ${qrDataURL ? `<img src="${qrDataURL}" alt="QR Code" />` : ''}
              </div>
            </div>

            <script>
              // Opcional: Auto imprimir al cargar
              // window.onload = function() { window.print(); };
            </script>
          </body>
        </html>
      `);

      printWindow.document.close();
    }
  }

async imprimirListadoTicket(ticket: any) {
  
    const textoTicket = ticket.mensajePrinter;
    const dataCodigoBarras = ticket.CodigoBarras;
    const dataCodigoQR = ticket.CodigoQR;

    let barcodeDataURL = '';
    if (dataCodigoBarras) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, dataCodigoBarras, {
        format: 'CODE128',
        width: 2,
        height: 50,
        displayValue: true,
        fontSize: 12,
        font: 'courier'
      });
      barcodeDataURL = canvas.toDataURL();
    }

    let qrDataURL = '';
    if (dataCodigoQR) {
      try {
        qrDataURL = await QRCode.toDataURL(dataCodigoQR, {
          errorCorrectionLevel: 'M',
          width: 150,
          margin: 1
        });
      } catch (err) {
        console.error('Error generando QR para listado', err);
      }
    }

    const printWindow = window.open('', '_blank', 'width=450,height=700,left=500,top=500');

    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Ticket Listado</title>
            <style>
              body {
                font-family: 'Courier New', Courier, monospace;
                font-size: 12px;
                margin: 0;
                padding: 10px;
              }
              .ticket-container {
                width: 100%;
                max-width: 350px;
                margin: 0 auto;
              }
              pre {
                white-space: pre-wrap;
                font-family: inherit;
                margin-bottom: 10px;
              }
              .codes {
                text-align: center;
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
              }
              img {
                max-width: 100%;
              }
              @media print {
                #print-btn { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="ticket-container">
              <button id="print-btn" onclick="window.print()" style="margin-bottom:10px; padding:5px 10px; cursor:pointer;">IMPRIMIR</button>
              
              <pre>${textoTicket}</pre>
              
              <div class="codes">
                ${barcodeDataURL ? `<img src="${barcodeDataURL}" alt="Barcode" />` : ''}
                ${qrDataURL ? `<img src="${qrDataURL}" alt="QR Code" />` : ''}
              </div>
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
    }
  }

  getElectronVersion(): string {
    console.log('electronVersion', window.api.electronIpcSendSync('getElectronVersion'));
    return window.api.electronIpcSendSync('getElectronVersion');
  }

}
